import React from 'react';
import { useTranslation } from 'react-i18next';
import AlertIcon from '@/images/alert-circle-outline.svg?react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
          <AlertIcon className="w-8 h-8 text-red-600" />
        </div>

        <h2 className="text-2xl font-bold text-text-primary mb-2">
          {t('common.error')}
        </h2>

        <p className="text-text-secondary mb-6">{t('errors.unknownError')}</p>

        <details className="mb-6 text-left">
          <summary className="cursor-pointer text-sm font-medium text-text-secondary hover:text-text-primary">
            Technical Details
          </summary>
          <pre className="mt-2 p-3 bg-base-100 rounded text-xs text-text-secondary overflow-auto">
            {error.message}
            {error.stack && (
              <>
                {'\n\n'}
                {error.stack}
              </>
            )}
          </pre>
        </details>

        <div className="space-y-3">
          <button
            onClick={resetErrorBoundary}
            className="btn btn-primary w-full"
          >
            Try Again
          </button>

          <button
            onClick={() => window.location.reload()}
            className="btn btn-outline w-full"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
